import script from "./SpinnerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SpinnerComponent.vue?vue&type=script&setup=true&lang=js"

import "./SpinnerComponent.vue?vue&type=style&index=0&id=b5a06a5e&lang=css"

const __exports__ = script;

export default __exports__